import React from 'react'
import { BmwServices } from './BmwServices'
import { DefaultServices } from './DefaultServices'
import { MentalWellbeingDaysServices } from './MentalWellbeingDaysServices'
import SportPsychologyServices from './SportPsychologyServices'

const CustomServicesMap = {
  '4ig': <MentalWellbeingDaysServices />,
  'bmw-mental-health': <BmwServices />,
  default: <DefaultServices />,
  mjsz: <SportPsychologyServices />,
}

export { CustomServicesMap }
export default CustomServicesMap
